import * as React from "react";
import { Box, Button, Stack, Typography } from "../../../components/mui";
import { EditRoundedIcon } from "../../../components/icons";

import "../../../styles/main.css";
import "../../../styles/pages/condoUnitDetail.css";

/**
 * CondoUnitInfoCard
 * Reusable display-only card for condo unit overview info.
 * Used on the condo unit detail page and can be reused inside modals.
 */
export default function CondoUnitInfoCard({
  title = "Condo Unit Info",
  items = [],
  showEdit = true,
  onEdit,
  columns = 6
}) {
  return (
    <Box className="condo-unit-detail-section">
      <Box className="condo-unit-detail-section-header">
        <Typography
          variant="subtitle1"
          className="card-title"
        >
          {title}
        </Typography>
        {showEdit && (
          <div className="condo-unit-detail-section-actions">
            <Stack direction="row" spacing={1}>
              <Button
                variant="outlined"
                size="small"
                className="condo-unit-detail-action-button"
                startIcon={<EditRoundedIcon />}
                onClick={onEdit}
              >
                Edit
              </Button>
            </Stack>
          </div>
        )}
      </Box>

      <Box
        className="expanded-row-grid"
        style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
      >
        {items.map((item) => (
          <Box
            className="expanded-row-item"
            key={`${item.label}-${item.value}`}
          >
            <Typography variant="caption" className="expanded-row-label">
              {item.label}:
            </Typography>
            <Typography variant="body2">
              {item.value || "—"}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
